import { Merge } from 'type-fest'

import { DipsSchemas } from '~/clients/dips-client'

export type DipsPostponementReason = DipsSchemas['CodedDto']
export type UnifiedDipsPostponementReason = Merge<DipsPostponementReason, { entity_type: 'dips_postponement_reason'; name: string; inUse: true }>

export function transformDipsPostponementReasons(postponementReasons: DipsPostponementReason[]): UnifiedDipsPostponementReason[] {
    return postponementReasons
        .filter(
            (postponementReason): postponementReason is DipsPostponementReason & { inUse: true; name: string } =>
                !!postponementReason.inUse && !!postponementReason.name
        )
        .map(postponementReason => ({
            ...postponementReason,
            entity_type: 'dips_postponement_reason',
        }))
}
